import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { BranchResponse } from "../../types/branch.type";
import { BRANCH_FIELD_CONFIG, CREATE_FIELDS, mapBranchToForm } from "./branchForm";

const EMPTY_VALUE = "-";

/** The branch manager's read-only view: the same fields, in the same layout, as the form. */
export default function BranchInfoView({ branch }: Readonly<{ branch: BranchResponse }>) {
  const values = mapBranchToForm(branch);

  return (
    <Grid container spacing={2}>
      {CREATE_FIELDS.map((field) => (
        <Grid key={field} size={{ xs: 12, sm: BRANCH_FIELD_CONFIG[field].gridSize }}>
          <Typography variant="caption" color="text.secondary">
            {BRANCH_FIELD_CONFIG[field].label}
          </Typography>
          <Typography variant="body2" fontWeight={600}>
            {values[field] || EMPTY_VALUE}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
}
